exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ref-link[data-v-69967f3c] {\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n.ref-link[data-v-69967f3c]:hover {\n  color: #2b93ff !important;\n}\n", ""]);

// exports
